import { mqMin, mqMax } from '../../breakpoints';

const base = {
  default: {},
  caseStudy: {
    '& .reactSelectDropdown__control': {
      border: 0,
      borderRadius: 0,
      borderBottomWidth: '1px',
      borderBottomStyle: 'solid',
      borderBottomColor: 'coolGrey.20',
      '&:hover, &--is-focused': {
        borderColor: 'coolGrey.20',
        boxShadow: 'none'
      },
      '&--is-focused': {
        'svg': {
          outline: 'auto'
        }
      }

    },
    '& .reactSelectDropdown__indicator-separator': {
      width: 0
    },
    '& .reactSelectDropdown__menu': {
      margin: 0,
      borderRadius: 0,
      backgroundColor: 'coolGrey.80',
      zIndex: 'z500'
    },
    '& .reactSelectDropdown__menu-list': {
      padding: 's4',
      display: 'flex',
      flexFlow: 'row wrap'
    },
    '& .reactSelectDropdown__option': {
      cursor: 'pointer',
      color: 'white',
      flex: '0 1 100%',
      fontSize: 'fs12',
      [mqMin.mobile]: {
        flex: '0 1 50%'
      },
      '&:hover, &:active, &--is-selected': {
        textDecoration: 'underline',
        background: 'transparent',
        outline: 'none'
      },
      '&--is-focused': {
        outline: 'auto',
        background: 'transparent',
      }
    }
  },
  languageSwitcher: {
    display: 'inline-block',
    flex: '0 1 140px',
    maxWidth: '100%',
    width: '140px',
    color: 'primary',
    marginRight: 's32',
    paddingBottom: '5px',
    '& .reactSelectDropdown__indicator': {
      display: 'none'
    },
    '& .reactSelectDropdown__menu-list': {
      maxHeight: '335px'
    },
    '& .reactSelectDropdown__control': {
      borderRadius: 0,
      backgroundColor: 'transparent',
      border: 0,
      '&:hover': {
        cursor: 'pointer'
      },
      '&--is-focused': {
        outline: 'auto !important',
        boxShadow: 'none',
        '+ .reactSelectDropdown__menu': {
          display: 'block'
        },
        '&::after': {
          transform: 'rotateX(180deg)'
        }
      },
      '&::after': {
        content: '""',
        position: 'absolute',
        left: '30px',
        top: '15px',
        backgroundImage: 'url("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAiIGhlaWdodD0iNiIgdmlld0JveD0iMCAwIDEwIDYiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgPHBhdGggZD0iTTEgMUw1IDVMOSAxIiBzdHJva2U9IiMyODJDMzMiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+Cg==")',
        backgroundSize: 'contain',
        backgroundRepeat: 'no-repeat',
        width: '12px',
        height: '7px',
        transition: 'transform 0.2s ease-out'
      }
    },
    '& .reactSelectDropdown__value-container': {
      paddingLeft: 0,
      paddingRight: '2px',
      [mqMax.computer]: {
        justifyContent: 'flex-start'
      },
      [mqMax.tabletSmall]: {
        justifyContent: 'center'
      }
    },
    '& .reactSelectDropdown__single-value ': {
      paddingLeft: '50px',
      height: '100%',
      '&::before': {
        content: '""',
        position: 'absolute',
        left: 0,
        top: 0,
        background: 'url("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8cGF0aCBkPSJNMTIgMjJDMTcuNTIyOCAyMiAyMiAxNy41MjI4IDIyIDEyQzIyIDYuNDc3MTUgMTcuNTIyOCAyIDEyIDJDNi40NzcxNSAyIDIgNi40NzcxNSAyIDEyQzIgMTcuNTIyOCA2LjQ3NzE1IDIyIDEyIDIyWiIgc3Ryb2tlPSIjMjgyQzMzIiBzdHJva2Utd2lkdGg9IjEuMjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgogIDxwYXRoIGQ9Ik0yIDEySDIyIiBzdHJva2U9IiMyODJDMzMiIHN0cm9rZS13aWR0aD0iMS4yNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CiAgPHBhdGggZD0iTTEwLjUzOTEgMi41QzguODcyNCA1IDYuMDM5MDcgMTIuNyAxMC4wMzkxIDIxLjUiIHN0cm9rZT0iIzI4MkMzMyIgc3Ryb2tlLXdpZHRoPSIxLjI1Ii8+CiAgPHBhdGggZD0iTTE0IDIuNUMxNS42NjY3IDUgMTguNSAxMi43IDE0LjUgMjEuNSIgc3Ryb2tlPSIjMjgyQzMzIiBzdHJva2Utd2lkdGg9IjEuMjUiLz4KICA8cGF0aCBkPSJNMjEuNzY5NSA5LjI2OTUzQzE5LjI2OTUgNy42MDI4NiAxMS41Njk1IDQuNzY5NTQgMi43Njk1MyA4Ljc2OTU0IiBzdHJva2U9IiMyODJDMzMiIHN0cm9rZS13aWR0aD0iMS4yNSIvPgogIDxwYXRoIGQ9Ik0yLjc2OTUzIDE0LjczMDVDNS4yNjk1MyAxNi4zOTcxIDEyLjk2OTUgMTkuMjMwNSAyMS43Njk1IDE1LjIzMDUiIHN0cm9rZT0iIzI4MkMzMyIgc3Ryb2tlLXdpZHRoPSIxLjI1Ii8+Cjwvc3ZnPgo=")',
        backgroundSize: 'cover',
        width: '20px',
        height: '20px'
      }
    },
    '& .reactSelectDropdown__placeholder': {
      color: 'secondary'
    },
    '& .reactSelectDropdown__indicator-separator': {
      display: 'none'
    },
    '& .reactSelectDropdown__menu': {
      backgroundColor: 'coolGrey.5',
      width: 'auto',
      borderRadius: 0,
      top: 'auto',
      bottom: '100%',
      padding: '0.5rem 0',
      left: '-8px',
      zIndex: 'z10',
      display: 'none',
      '&::after': {
        bottom: '-11px',
        left: '10px',
        content: '""',
        height: '20px',
        width: '20px',
        position: 'absolute',
        pointerEvents: 'none',
        backgroundColor: 'coolGrey.5',
        borderBottomWidth: '1px',
        borderBottomStyle: 'solid',
        borderBottomColor: 'coolGrey.20',
        borderRightWidth: '1px',
        borderRightStyle: 'solid',
        borderRightColor: 'coolGrey.20',
        zIndex: 'zNegative1',
        transform: 'rotate(45deg)'
      },
      [mqMax.mobile]: {
        left: 'unset'
      }
    },
    '& .reactSelectDropdown__option': {
      color: 'black',
      backgroundColor: 'transparent',
      paddingLeft: '20px',
      '&:first-of-type': {
        paddingTop: '15px'
      },
      '&:last-child': {
        paddingBottom: '15px'
      },
      '&:hover': {
        cursor: 'pointer',
        backgroundColor: 'transparent'
      }
    },
    '& .reactSelectDropdown__link': {
      display: 'block',
      padding: '0.25rem 1.5rem',
      fontWeight: 'regular',
      '&--is-selected': {
        color: 'primary',
        '&::after': {
          content: '"✓"',
          marginLeft: '5px',
          color: 'primary'
        },
        '&:hover': {
          color: 'secondary',
          '&::after': {
            color: 'secondary'
          }
        }
      },
      '&--is-focused': {
        outline: 'auto'
      }
    },
  },
  product: {
    borderBottomWidth: '4px',
    borderBottomStyle: 'solid',
    borderBottomColor: 'coolGrey.100',
    marginBottom: 's32',
    width: '100%',
    [mqMin.tablet]: {
      minWidth: '240px',
      width: 'auto'
    },
    '& .reactSelectDropdown__control': {
      border: 'none',
      boxShadow: 'none',
      '&--is-focused': {
        outline: 'auto !important'
      }
    },
    '& .reactSelectDropdown__indicator': {
      color: 'coolGrey.100',
      '&-separator': {
        backgroundColor: 'transparent',
      }
    }
  },
  sort: {
    width: '100%',
    zIndex: 'z100',
    minWidth: '140px',
    '& .reactSelectDropdown__control': {
      borderWidth: '1px',
      borderStyle: 'solid',
      borderColor: 'coolGrey.40',
      padding: 's4',
      '&--is-focused': {
        'svg': {
          outline: 'auto'
        }
      }
    },
    '& .reactSelectDropdown__indicator': {
      color: 'coolGrey.100',
      '&-separator': {
        backgroundColor: 'transparent',
      },
    },
    '& .reactSelectDropdown__option': {
      '&--is-focused': {
        outline: 'auto',
        outlineOffset: '-1px',
        background: 'transparent',
      },
      '&--is-selected': {
        color: 'coolGrey.100',
        background: 'transparent'
      }
    }
  }
};

export type FormDropdownVariantsType = 'default' | 'caseStudy' | 'languageSwitcher' | 'product' | 'sort';

export const formDropdownVariants = Object.keys(base) as FormDropdownVariantsType[];

const dropdown = {
  products: {
    chart: base,
    chartblog: base,
    co: base,
    edu: base,
    scale: base,
    spark: base
  }
};

export default dropdown;
